module.exports = __webpack_public_path__ + "img/icon-security-restrictions.b1d6bd24.svg";